import {
  QuizQuestionAnswer,
  QuizQuestion,
  QuizQuestionAnswerKey,
  QuizQuestionInputType,
} from "@platform/types/quiz.types";

export type Args = {
  question: QuizQuestion;
  answer: QuizQuestionAnswer;
  quizResponseId: number;
};

export function packAnswerPayload({ question, answer, quizResponseId }: Args) {
  let key: QuizQuestionAnswerKey = "selected_quiz_choices";

  const { type } = question;

  if (
    [
      "multi-select",
      "multiple choice",
      "select",
      "checkbox",
      "slider",
      "organization selector",
      "yes/no-buttons",
      "yes/no",
    ].includes(type as QuizQuestionInputType)
  ) {
    key = "selected_quiz_choices";
  }

  if (type === "text input") {
    key = "answer_text";
  }

  return {
    quiz_response: quizResponseId,
    question: question.id,
    [key]: answer,
  };
}
